import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL

export const getUserList = createAsyncThunk("user/getUsers", async ({ page = 1, filters = {} }, thunkAPI) => {
  try {
    const queryParams = new URLSearchParams({
        page,
        limit: 10,
        ...filters,
      });
    // const token = localStorage.getItem("access_token");
    const res = await axios.get(`${BACKEND_URL}/user/list?${queryParams.toString()}`);
    return res.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch clients");
  }
});

const userListingSlice = createSlice({
  name: "userListing",
    initialState: {
      users: [],
      pagination: {},
      loading: false,
      error: null,
    },
    extraReducers: (builder) => {
      builder
        .addCase(getUserList.pending, (state) => {
            state.loading = true;
        })
        .addCase(getUserList.fulfilled, (state, action) => {
            state.users = action.payload.data;
            state.pagination = {
                current_page: action.payload.current_page,
                last_page: action.payload.last_page,
                total: action.payload.total,
            };
            state.loading = false;
        })
        .addCase(getUserList.rejected, (state, action) => {
            state.error = action.payload || "Failed to fetch users"; 
            state.loading = false;
        })
    },
});

export default userListingSlice.reducer;